import {createContext} from 'react'

import {History} from 'history'
import QueryString from 'querystring'
/**
 * Контекст парсинга QueryString из URL
 */
export const QueryStringContext = createContext<QueryString.ParsedUrlQuery>({})

/**
 * Контекст парсинга QueryString из хэша в URL
 */
export const HashQueryStringContext = createContext<QueryString.ParsedUrlQuery>({})

/**
 * Контекст с history (обычной)
 */
export const HistoryContext = createContext<History>(null as unknown as History)
/**
 * Контекст с Hash history
 */
export const HashHistoryContext = createContext<History>(null as unknown as History)

export const HistoryProvider = HistoryContext.Provider
export const HashHistoryProvider = HashHistoryContext.Provider
